/**
 * @generated SignedSource<<883d7229d77f7c6a686a5d8f4cedeb73>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ParseProductPromptInput = {
  prompt: string;
};
export type printAreasParseProductPromptMutation$variables = {
  input: ParseProductPromptInput;
};
export type printAreasParseProductPromptMutation$data = {
  readonly parseProductPrompt: {
    readonly error: string | null;
    readonly productName: string;
    readonly sides: ReadonlyArray<{
      readonly imagePrompt: string;
      readonly name: string;
    }>;
    readonly success: boolean;
  };
};
export type printAreasParseProductPromptMutation = {
  response: printAreasParseProductPromptMutation$data;
  variables: printAreasParseProductPromptMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ParseProductPromptOutput",
    "kind": "LinkedField",
    "name": "parseProductPrompt",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ParsedProductSide",
        "kind": "LinkedField",
        "name": "sides",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imagePrompt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "printAreasParseProductPromptMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "printAreasParseProductPromptMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b2b673403d4bcc085a88a59ac63abfbd",
    "id": null,
    "metadata": {},
    "name": "printAreasParseProductPromptMutation",
    "operationKind": "mutation",
    "text": "mutation printAreasParseProductPromptMutation(\n  $input: ParseProductPromptInput!\n) {\n  parseProductPrompt(input: $input) {\n    success\n    error\n    productName\n    sides {\n      name\n      imagePrompt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02375294a6189800f9013b37971d71de";

export default node;
